// messaging.service.ts
import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {
  constructor(private afMessaging: AngularFireMessaging,public toastr : ToastrService) {
    this.recieveMessaging();
  }

  requestPermission() {
    this.afMessaging.requestToken
      .subscribe(
        (token) => {
          console.log('FCM Token:', token),
        localStorage.setItem('notificationToken',token)
        },
        (error) => console.error('Permission denied', error)
      );
  }

  recieveMessaging() {
    this.afMessaging.messages
      .subscribe((message:any) => {
        this.toastr.info(message)
        console.log('message',message);

        localStorage.setItem('receiveMsg',JSON.stringify(message))
      });
  }
}
